export const productSearchSettings = {
  itemsPerPage: 24,
  featuredProductsCount: 6
};
